export function AdminLocal (pConfig)
{
  return (
  {
    name : 'EditorToolbarLocalConfig',

    Groups :
    [
      {
        name : 'HistoryActionsPublic',
        visible : true
      },

      {
        name : 'BlockActionsPublic',
        visible : true
      },

      {
        name : 'TextAlignPublic',
        visible : true
      },

      {
        name : 'FontColorsPublic',
        visible : true
      },

      {
        name : 'InsertPublic',
        visible : true
      },

      {
        name : 'MoreLocalActions',
        visible : true
      },

      {
        name : 'BlockStylesPublic',
        visible : true,
        lineBreak : true
      },

      {
        name : 'TextDecorationPublic',
        visible : true
      },

      {
        name : 'TextDecorationDropdownPublic',
        visible : true,
        isDropdown: true
      }
    ]
  });
}